import { ModelBase } from 'store/model-base';
import { DataPlanType, DataPlanTypePlanSeven } from 'core/constants';

export class planEligibilityDetails extends ModelBase {
    public static storeName: string = 'planEligibilityDetails';

    public lineId: string;
    public currentPlan: CurrentPlanDetails;
    public eligiblePlans: EligiblePlans;
    public promotionContent: PromotionContent[];
    public isActiveUnlimitedPlan: boolean;
    public isBTGActivePlan: boolean;
    public isTabletActivePlan: boolean;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.isActiveUnlimitedPlan = Object.values(DataPlanType).some((planType: string) => data.currentPlan.planName.toUpperCase().includes(planType));
        data.isBTGActivePlan = data.currentPlan.planName.toUpperCase() === DataPlanTypePlanSeven.BY_THE_GIG;
        data.isTabletActivePlan  = data.currentPlan.planName.toUpperCase().includes('TABLET');

        return super.create<T>(data);
    }
}
